import { convertFormDataToUrlSearchParams } from '@lib/utils/url'

export const sendDefault = async (submitUrl: string, formData: FormData) => {
  const body = convertFormDataToUrlSearchParams(formData)

  if ('sendBeacon' in navigator) {
    // We are not processing response. The 'sendBeacon' API is faster than 'fetch' API, increasing form submission speed.
    return await navigator.sendBeacon(submitUrl, body)
  }

  return await fetch(submitUrl, {
    body,
    method: 'post',
    mode: 'no-cors',
    credentials: 'include',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}
